function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export default function getCardClasses(className, cardSize, extra) {
  var _ref;

  return _ref = {}, _defineProperty(_ref, className, true), _defineProperty(_ref, "".concat(className, "--").concat(cardSize), {
    sm: true,
    lg: true
  }[cardSize]), _defineProperty(_ref, "".concat(className, "--").concat(extra), extra), _ref;
}